import { useLocale } from '@hooks/useLocale';
import { Box, Loader, LoadingOverlay, Text } from '@mantine/core';
import { PageLoaderColor } from '@utils/mantineTheme';
import React, { useMemo } from 'react';

interface PageSpinnerProps {
    withOverlay?: boolean;
    isVisible?: boolean;
    loaderColor?: PageLoaderColor;
    loaderText?: string;
}

const PageSpinner: React.FC<PageSpinnerProps> = ({
    withOverlay,
    isVisible,
    loaderColor,
    loaderText,
}) => {
    const { t } = useLocale();

    const getLoaderColor = useMemo(() => {
        if (loaderColor === PageLoaderColor.GRAY) {
            return 'rgb(var(--color-gray-500))';
        }
        return 'rgb(var(--color-blu-800))';
    }, [loaderColor]);

    const loader = useMemo(
        () => (
            <Box className="flex flex-col gap-2 items-center">
                <Loader color={getLoaderColor} variant="bars" />
                <Text className="text-gray-600">
                    {loaderText ?? t('page_spinner.default_loader_text')}
                </Text>
            </Box>
        ),
        [getLoaderColor, loaderText, t],
    );

    if (withOverlay) {
        return (
            <LoadingOverlay
                visible={isVisible ?? true}
                overlayBlur={2}
                overlayOpacity={0.4}
                loader={loader}
            />
        );
    }

    return (
        <Box className="flex flex-col justify-center items-center w-full h-screen">
            {loader}
        </Box>
    );
};

export default PageSpinner;
